import { useState, useEffect } from "react";
import API from "../api";

export default function Settings() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    notifications: true,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  /* ===============================
     LOAD USER DATA
  =============================== */
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      setForm((prev) => ({
        ...prev,
        name: user.name || "",
        email: user.email || "",
      }));
    }
  }, []);

  /* ===============================
     HANDLE CHANGE
  =============================== */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  /* ===============================
     SAVE SETTINGS (CONNECTED TO API)
  =============================== */
  const handleSave = async () => {
    setMessage("");

    if (!form.name || !form.email) {
      setMessage("⚠️ Name and Email are required");
      return;
    }

    if (form.password && form.password !== form.confirmPassword) {
      setMessage("⚠️ Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const token =
        localStorage.getItem("token") ||
        sessionStorage.getItem("token");

      const res = await fetch(`${API}/auth/update-profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.success) {
        setMessage("✅ Settings updated successfully");

        // 🔥 Update localStorage user
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: form.name,
            email: form.email,
          })
        );

        // 🔥 Clear password fields
        setForm((prev) => ({
          ...prev,
          password: "",
          confirmPassword: "",
        }));

      } else {
        setMessage(`❌ ${data.message || "Update failed"}`);
      }

    } catch (err) {
      console.error(err);
      setMessage("❌ Server error");
    }

    setLoading(false);
  };

  return (
    <div className="space-y-6">

      {/* HEADER */}
      <div>
        <h2 className="text-3xl font-bold mb-2">Settings</h2>
        <p className="text-gray-500">
          Manage your account and preferences
        </p>
      </div>

      {/* MESSAGE */}
      {message && (
        <div className="p-3 rounded-lg text-sm bg-gray-100">
          {message}
        </div>
      )}

      {/* PROFILE */}
      <div className="bg-white p-6 rounded-xl shadow-sm border">
        <h3 className="text-lg font-semibold mb-4">
          Profile Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Full Name"
            className="p-3 border rounded-lg focus:ring-2 focus:ring-green-500"
          />

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email"
            className="p-3 border rounded-lg focus:ring-2 focus:ring-green-500"
          />

        </div>
      </div>

      {/* PASSWORD */}
      <div className="bg-white p-6 rounded-xl shadow-sm border">
        <h3 className="text-lg font-semibold mb-4">
          Change Password
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="New Password"
            className="p-3 border rounded-lg focus:ring-2 focus:ring-green-500"
          />

          <input
            type="password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleChange}
            placeholder="Confirm Password"
            className="p-3 border rounded-lg focus:ring-2 focus:ring-green-500"
          />

        </div>
      </div>

      {/* NOTIFICATIONS */}
      <div className="bg-white p-6 rounded-xl shadow-sm border flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold">
            Email Notifications
          </h3>
          <p className="text-sm text-gray-500">
            Receive updates and alerts via email
          </p>
        </div>

        <input
          type="checkbox"
          name="notifications"
          checked={form.notifications}
          onChange={handleChange}
          className="w-5 h-5 accent-green-600"
        />
      </div>

      {/* SAVE BUTTON */}
      <div>
        <button
          onClick={handleSave}
          disabled={loading}
          className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
        >
          {loading ? "Saving..." : "Save Changes"}
        </button>
      </div>

    </div>
  );
}